import type { FC, SVGProps } from 'react'

export const LightningBolt: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g id="Premium voice">
      <path
        id="Icon"
        d="M3.74606 9.06706L8.81705 2.72831C9.69095 1.63594 10.1279 1.08976 10.5111 1.02949C10.8428 0.977327 11.1785 1.09509 11.4049 1.34302C11.6664 1.62945 11.6664 2.32891 11.6664 3.72782V6.73323C11.6664 7.29329 11.6664 7.57331 11.7754 7.78722C11.8713 7.97539 12.0243 8.12837 12.2125 8.22424C12.4264 8.33323 12.7064 8.33323 13.2664 8.33323H15.0041C16.0698 8.33323 16.6027 8.33323 16.8763 8.55169C17.1144 8.74168 17.2528 9.02977 17.2525 9.33431C17.2521 9.68449 16.9192 10.1006 16.2535 10.9327L11.1825 17.2715C10.3086 18.3639 9.87166 18.91 9.48848 18.9703C9.15681 19.0225 8.82109 18.9047 8.59468 18.6568C8.33311 18.3703 8.33311 17.6709 8.33311 16.272V13.2666C8.33311 12.7065 8.33311 12.4265 8.22412 12.2126C8.12824 12.0244 7.97526 11.8714 7.7871 11.7756C7.57319 11.6666 7.29316 11.6666 6.73311 11.6666H4.99545C3.92975 11.6666 3.3969 11.6666 3.12322 11.4481C2.88521 11.2581 2.74674 10.97 2.74707 10.6655C2.74745 10.3153 3.08032 9.89923 3.74606 9.06706Z"
        fill="currentColor"
      />
    </g>
  </svg>
)
